export { isNextCharacterText } from './isNextCharacterText';
export { isNextCharacterWhitespaceOrEnd } from './isNextCharacterWhitespaceOrEnd';
export { isPreviousCharacterWhitespaceOrStart } from './isPreviousCharacterWhitespaceOrStart';
